/*
 * Action Types
 */
export enum ProductTypes {
  LIST_PRODUCTS_REQUEST = '@product/LIST_PRODUCTS_REQUEST',
  LIST_PRODUCTS_SUCCESS = '@product/LIST_PRODUCTS_SUCCESS',
  LIST_PRODUCTS_FAILURE = '@product/LIST_PRODUCTS_FAILURE',

  LIST_TICKET_RESAVATION_SUCCESS = '@product/LIST_TICKET_RESAVATION_SUCCESS',

  FILTER_PRODUCTS_REQUEST = '@product/FILTER_PRODUCTS_REQUEST',
  FILTER_PRODUCTS_SUCCESS = '@product/FILTER_PRODUCTS_SUCCESS',
  FILTER_PRODUCTS_FAILURE = '@product/FILTER_PRODUCTS_FAILURE',

  CREATE_PRODUCT_REQUEST = '@product/CREATE_PRODUCT_REQUEST',
  CREATE_PRODUCT_SUCCESS = '@product/CREATE_PRODUCT_SUCCESS',
  CREATE_PRODUCT_FAILURE = '@product/CREATE_PRODUCT_FAILURE',

  UPDATE_PRODUCT_REQUEST = '@product/UPDATE_PRODUCT_REQUEST',
  UPDATE_PRODUCT_SUCCESS = '@product/UPDATE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_FAILURE = '@product/UPDATE_PRODUCT_FAILURE',

  DELETE_PRODUCT_REQUEST = '@product/DELETE_PRODUCT_REQUEST',
  DELETE_PRODUCT_SUCCESS = '@product/DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_FAILURE = '@product/DELETE_PRODUCT_FAILURE',
}

/*
 * Data types
 */
export interface ProductInterface {
  id: string;
  title: string;
  type: string;
  availability: string;
  status: number;
  data: {
    firstValue: number;
    secondValue: number;
    exceptions: Array<string>;
  };
  picture: string;
  createdAt: string;
  updatedAt: string;
}
export interface FareExportType {
  type: string;
  operation: string;
  value: number | null;
  applyWithFareBonus?: boolean | null;
}
export interface FareDateType {
  appUser: FareExportType;
  sellingTerminal: FareExportType;
  website: FareExportType;
}
export interface TicketResevationInterface {
  id: string;
  title: string;
  type: string;
  availability: string;
  status: number;
  data: {
    availability: {
      user: boolean;
      sellingOwn: boolean;
      sellingExternal: boolean;
      website: boolean;
    };
    fare: FareDateType | FareExportType | null;
    carType: [];
    profileIds: [];
    sellingLimits: {
      passengers: {
        value: number;
        type: string;
      };
      cars: {
        value: number;
        type: string;
      };
    };
    sellingTiming: {
      start: {
        value: number;
        type: string;
      };
      end: {
        value: number;
        type: string;
      };
    };
    freeMaxTime: number;
    showDepartureTimeOnly: boolean;
  };
  picture: string;
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface ProductState {
  readonly productsList: ProductInterface[];
  readonly ticketResavationList: TicketResevationInterface[];
  readonly product: ProductInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
